import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-calendar\"><g fill=\"transparent\" stroke-width=\"1.5\" stroke=\"currentColor\"><path d=\"M11.619 6h4.762m3.947.5h1.767C23.147 6.5 24 7.346 24 8.389V21.61a1.897 1.897 0 01-1.905 1.889H5.905A1.897 1.897 0 014 21.611V8.39c0-1.044.853-1.89 1.905-1.89H8.13\" /><path stroke-linecap=\"square\" d=\"M4.5 11h19m-5-7v3m-9-3v3m-1 8h3m-3 4h3m5-4h3m-3 4h3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol